import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './GoblinsTrapKillNotice.css';
import {selectGoblinsTrapKillNoticeState} from '../../redux/reducers/privateStateReducer/selectors';
import {hideGoblinsTrapKillNotice} from '../../redux/actions';
import {GOBLINS_TRAP_KILL_NOTICE_AUTO_HIDE_MS} from '../../configs/factions/goblins';

/**
 * Немедленное подтверждение срабатывания ловушки Гоблинов по своему отряду
 * (см. openspec/changes/add-goblins-faction design.md Decision 12/20/21) —
 * показывается при ЛЮБОМ срабатывании (отряд выжил или погиб), не только
 * при гибели, и ТОЛЬКО когда blocking: true — это ставится лишь на клиенте
 * игрока-человека, чей отряд только что двигался; для чужого/бот-хода то же
 * состояние используется ТОЛЬКО индикаторами на поле (см.
 * HexGridRenderer.updateGoblinsTrapTriggerDisplay), без этой карточки.
 *
 * Карточка гаснет сама через GOBLINS_TRAP_KILL_NOTICE_AUTO_HIDE_MS или по
 * клику по ней — и уносит с собой ТОЛЬКО себя: индикаторы на поле живут до
 * конца этапа. Полноэкранного слоя-перехватчика у нее больше нет: он съедал
 * колесо мыши и жесты, из-за чего под карточкой не работал зум поля (найдено
 * пользователем). Клики по полю никто не перехватывает — карточка все равно
 * уходит по таймеру, и глушить ради нее ход игрока незачем. Сознательно НЕ
 * построено на ModalWindow: та затемняет весь экран, что скрыло бы уже
 * отображённые на поле индикаторы срабатывания ловушек (сколько урона, чья
 * ловушка).
 */
const GoblinsTrapKillNotice = () => {
  const dispatch = useDispatch();
  const {show, blocking, isNoticeVisible, unit, died} = useSelector(selectGoblinsTrapKillNoticeState);
  const isVisible = show && blocking && isNoticeVisible;

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }
    const timeoutId = setTimeout(() => dispatch(hideGoblinsTrapKillNotice()), GOBLINS_TRAP_KILL_NOTICE_AUTO_HIDE_MS);
    return () => clearTimeout(timeoutId);
  }, [isVisible, dispatch]);

  if (!isVisible) {
    return null;
  }

  const handleClose = (event) => {
    event.stopPropagation();
    dispatch(hideGoblinsTrapKillNotice());
  };

  const unitLabel = unit?.label ? ` (${unit.label})` : '';
  const text = died
    ? `Ваш отряд${unitLabel} подорвался на ловушке гоблинов и погиб.`
    : `Ваш отряд${unitLabel} попал в ловушку гоблинов!`;

  return (
    <div className={'goblins-trap-kill-notice_card'} onClick={handleClose}>
      <img className={'goblins-trap-kill-notice_icon'} src={'/img/icons/trap_white.png'} alt={'trap'}/>
      <div className={'goblins-trap-kill-notice_text'}>
        {text}
      </div>
    </div>
  );
};

export default GoblinsTrapKillNotice;
